import { type FC } from "react";
import { useWatch } from "react-hook-form";
import { type InputNotAdoptedDetailProps } from "@clientFrontend/features/entry/components/NotAdopted/type";
import { SpView } from "./uiParts/SpView";
import { PcView } from "./uiParts/PcView";

export const InputNotAdoptedDetail: FC<InputNotAdoptedDetailProps> = ({
  notAdoptedReasons,
  completedInterview,
  isPayPerJobEntryFeeType,
  handleRadioButtonChange,
  isChecked,
  handleChangeCheckbox,
  notAdoptedDescriptionTextLength,
  handleTextAreaChange,
  recruitmentFeePath,
  isSp,
}) => {
  const selectBoxOptions = notAdoptedReasons.map(([label, value]) => {
    return { label, value };
  });

  const selectedReason = useWatch({
    name: "not_adopted_reason",
  });

  return (
    <>
      {isSp ? (
        <SpView
          completedInterview={completedInterview}
          isPayPerJobEntryFeeType={isPayPerJobEntryFeeType}
          handleRadioButtonChange={handleRadioButtonChange}
          isChecked={isChecked}
          handleChangeCheckbox={handleChangeCheckbox}
          notAdoptedDescriptionTextLength={notAdoptedDescriptionTextLength}
          handleTextAreaChange={handleTextAreaChange}
          recruitmentFeePath={recruitmentFeePath}
          selectBoxOptions={selectBoxOptions}
          selectedReason={selectedReason}
        />
      ) : (
        <PcView
          completedInterview={completedInterview}
          isPayPerJobEntryFeeType={isPayPerJobEntryFeeType}
          handleRadioButtonChange={handleRadioButtonChange}
          isChecked={isChecked}
          handleChangeCheckbox={handleChangeCheckbox}
          notAdoptedDescriptionTextLength={notAdoptedDescriptionTextLength}
          handleTextAreaChange={handleTextAreaChange}
          recruitmentFeePath={recruitmentFeePath}
          selectBoxOptions={selectBoxOptions}
          selectedReason={selectedReason}
        />
      )}
    </>
  );
};
